import { render, staticRenderFns } from "./redReversal.vue?vue&type=template&id=6efc1104&scoped=true&"
import script from "./redReversal.vue?vue&type=script&lang=js&"
export * from "./redReversal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc1104",
  null
  
)

export default component.exports